export const MAX_CURRENCY_VALUE = 999999.99;
export const isValueBelowMax = (value, maxValue) => {
    return value <= maxValue;
};
export const isValidNumericValue = (value, maxValue = MAX_CURRENCY_VALUE) => {
    return value >= 0 && isValueBelowMax(value, maxValue);
};
